/**
 * Triple Whale Tracking Functions
 * 
 * Helper functies voor het tracken van events met Triple Whale
 * Gebaseerd op de officiële Triple Whale documentatie
 */

(function() {
    'use strict';
    
    function isTriplePixelReady() {
        return typeof TriplePixel === 'function';
    }
    
    window.tripleWhaleTrack = {
        custom: function(eventName, properties = {}) {
            if (isTriplePixelReady()) {
                try {
                    TriplePixel(eventName, properties);
                } catch (error) {
                    console.warn('[Triple Whale] Fout bij verzenden custom event:', error);
                }
            }
        },
        
        addToCart: function(productId, quantity = 1, variantId) {
            if (isTriplePixelReady()) {
                try {
                    const data = { item: productId, q: quantity };
                    if (variantId) { data.v = variantId; }
                    TriplePixel('AddToCart', data);
                } catch (error) {
                    console.warn('[Triple Whale] Fout bij verzenden Add to Cart event:', error);
                }
            }
        },
        
        contact: function(email = null, phone = null, firstName = null, lastName = null) {
            if (isTriplePixelReady()) {
                try {
                    const data = {};
                    if (email) { data.email = email; }
                    if (phone) { data.phone = phone; }
                    if (firstName) { data.firstName = firstName; }
                    if (lastName) { data.lastName = lastName; }
                    if (Object.keys(data).length > 0) {
                        TriplePixel('Contact', data);
                    }
                } catch (error) {
                    console.warn('[Triple Whale] Fout bij verzenden Contact event:', error);
                }
            }
        },
        
        pageLoad: function() {
            if (isTriplePixelReady()) {
                try {
                    TriplePixel('pageLoad');
                } catch (error) {
                    console.warn('[Triple Whale] Fout bij pageLoad tracking:', error);
                }
            }
        },
        
        purchase: function(orderData) {
            if (isTriplePixelReady()) {
                try {
                    const data = {
                        eventId: orderData.eventId || 'purchase_' + Date.now(),
                        email: orderData.email || '',
                        phone: orderData.phone || '',
                        firstName: orderData.firstName || '',
                        lastName: orderData.lastName || '',
                        orderId: orderData.orderId,
                        cotkn: orderData.cotkn || 've_' + orderData.orderId + '_' + Date.now(),
                        lineItems: orderData.lineItems || [],
                        address: orderData.address || {
                            zip: '',
                            city: '',
                            countryCode: '',
                            provinceCode: ''
                        }
                    };
                    TriplePixel('purchase', data);
                } catch (error) {
                    console.warn('[Triple Whale] Fout bij verzenden purchase event:', error);
                }
            }
        },
        
        checkoutStarted: function(checkoutData) {
            if (isTriplePixelReady()) {
                try {
                    const data = {
                        eventId: checkoutData.eventId || 'checkout_' + Date.now(),
                        email: checkoutData.email || '',
                        phone: checkoutData.phone || '',
                        firstName: checkoutData.firstName || '',
                        lastName: checkoutData.lastName || '',
                        orderId: checkoutData.orderId || '',
                        cotkn: checkoutData.cotkn || 've_checkout_' + Date.now(),
                        lineItems: checkoutData.lineItems || [],
                        address: checkoutData.address || {
                            zip: '',
                            city: '',
                            countryCode: '',
                            provinceCode: ''
                        }
                    };
                    TriplePixel('checkoutStarted', data);
                } catch (error) {
                    console.warn('[Triple Whale] Fout bij verzenden checkoutStarted event:', error);
                }
            }
        }
    };
})();
